import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DeviceServiceV2 } from '@devices';
import { type NormalizedDeviceData } from '@devices';
import { LocationActions } from '@locations';
import { Store } from '@ngrx/store';
import { MessageComponent } from '@ui';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

type ConfirmDeleteRoomDialogProps = {
  floorId: string;
  locationId: string;
  name: string;
  navigateToParent: boolean;
  roomId: string;
};

@Component({
  imports: [MatDialogModule, NgxSkeletonLoaderModule, MessageComponent],
  selector: 'avs-fe-confirm-delete-room-dialog',
  templateUrl: './confirm-delete-room-dialog.component.html',
})
export class ConfirmDeleteRoomDialogComponent {
  protected dialogRef = inject(MatDialogRef<ConfirmDeleteRoomDialogComponent>);
  protected devices = signal<NormalizedDeviceData[]>([]);
  protected devicesLoading = signal(false);
  protected data = inject<ConfirmDeleteRoomDialogProps>(MAT_DIALOG_DATA);
  private deviceServiceV2 = inject(DeviceServiceV2);
  private store = inject(Store);

  constructor() {
    this.fetchDevices(this.data.roomId);
  }

  protected confirm() {
    this.store.dispatch(LocationActions.deleteRoom({
      floorId: this.data.floorId,
      locationId: this.data.locationId,
      navigateToParent: this.data.navigateToParent,
      roomId: this.data.roomId,
    }));
    this.dialogRef.close(true);
  }

  private fetchDevices(spaceId: string) {
    this.devicesLoading.set(true);
    this.deviceServiceV2.list({
      filters: { space: spaceId },
      sort: {
        active: 'deviceName',
        direction: 'asc',
      },
    }).subscribe(({ data }) => {
      this.devices.set(data);
      this.devicesLoading.set(false);
    });
  }
}

export function openDeleteRoomDialog(dialog: MatDialog, data: ConfirmDeleteRoomDialogProps) {
  const config = new MatDialogConfig();

  config.disableClose = true;
  config.data = {
    ...data,
  };
  config.autoFocus = false;
  config.backdropClass = 'backdrop-modal-panel';
  const dialogRef = dialog.open(ConfirmDeleteRoomDialogComponent, config);

  return dialogRef.afterClosed();
}
